import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireCjs } from '../node_modules/.pnpm/xml-formatter@3.7.0/node_modules/xml-formatter/dist/cjs/index.js';

var cjsExports = /*@__PURE__*/ requireCjs();
const xmlFormatter = /*@__PURE__*/getDefaultExportFromCjs(cjsExports);

export { xmlFormatter as default };
//# sourceMappingURL=index.js.map
